import SharedNavigateModals from './SharedNavigateModals';

export default SharedNavigateModals;
